// カスタムブラシ先端 (サンプル先端)。選択範囲の画像から「暗いほど不透明」なアルファを作る。純ロジック。

export interface BrushTip {
  id: string
  name: string
  w: number
  h: number
  /** 0..255 のアルファ (行優先) */
  data: Uint8Array
}

export const TIP_MAX = 256

/** RGBA と (任意の) 選択アルファから先端を作る。長辺が TIP_MAX を超えれば面積平均で縮小 */
export function tipFromRgba(rgba: Uint8ClampedArray, w: number, h: number, sel?: Uint8ClampedArray | null): { w: number; h: number; data: Uint8Array } {
  const full = new Float32Array(w * h)
  for (let i = 0; i < w * h; i++) {
    const a = rgba[i * 4 + 3]! / 255
    const lum = (0.299 * rgba[i * 4]! + 0.587 * rgba[i * 4 + 1]! + 0.114 * rgba[i * 4 + 2]!) / 255
    // 白 = 透明、黒 = 不透明 (Photoshop の「ブラシを定義」と同じ)
    let v = (1 - lum) * a
    if (sel) v *= sel[i]! / 255
    full[i] = v
  }
  const s = Math.max(1, Math.max(w, h) / TIP_MAX)
  const ow = Math.max(1, Math.round(w / s)), oh = Math.max(1, Math.round(h / s))
  const data = new Uint8Array(ow * oh)
  for (let y = 0; y < oh; y++) for (let x = 0; x < ow; x++) {
    const x0 = Math.floor(x * s), x1 = Math.max(x0 + 1, Math.floor((x + 1) * s)), y0 = Math.floor(y * s), y1 = Math.max(y0 + 1, Math.floor((y + 1) * s))
    let sum = 0, n = 0
    for (let yy = y0; yy < y1 && yy < h; yy++) for (let xx = x0; xx < x1 && xx < w; xx++) { sum += full[yy * w + xx]!; n++ }
    data[y * ow + x] = n ? Math.round((sum / n) * 255) : 0
  }
  return { w: ow, h: oh, data }
}

/** 先端を正方形 (size×size) の中央に置いたテクスチャデータにする */
export function tipToSquare(tip: { w: number; h: number; data: Uint8Array }): { size: number; data: Uint8Array } {
  const size = Math.max(tip.w, tip.h)
  const out = new Uint8Array(size * size)
  const ox = Math.floor((size - tip.w) / 2), oy = Math.floor((size - tip.h) / 2)
  for (let y = 0; y < tip.h; y++) out.set(tip.data.subarray(y * tip.w, (y + 1) * tip.w), (oy + y) * size + ox)
  return { size, data: out }
}

export function encodeTipData(data: Uint8Array): string {
  let s = ''
  for (let i = 0; i < data.length; i += 0x8000) s += String.fromCharCode(...data.subarray(i, i + 0x8000))
  return typeof btoa === 'function' ? btoa(s) : Buffer.from(s, 'binary').toString('base64')
}
export function decodeTipData(b64: string, length: number): Uint8Array | null {
  try {
    const s = typeof atob === 'function' ? atob(b64) : Buffer.from(b64, 'base64').toString('binary')
    if (s.length !== length) return null
    const out = new Uint8Array(length)
    for (let i = 0; i < length; i++) out[i] = s.charCodeAt(i)
    return out
  } catch {
    return null
  }
}
